import React from "react";
import { MdDomain } from "react-icons/md";
import { useNavigate } from "react-router-dom";

function WhitelistDomain() {
  const navigate = useNavigate();
  return (
    <div
      className="flex items-center gap-2 "
      onClick={() => {
        navigate("/whitelist");
      }}
    >
      <div className="hidden lg:flex">
        <MdDomain className="text-xl text-gray-700" />
      </div>
      <div className="flex lg:hidden px-5 w-full items-center gap-2">
        <MdDomain className="text-xl text-gray-700" />
        <span className="text-sm text-gray-600">Whitelist domain</span>
      </div>
    </div>
  );
}

export default WhitelistDomain;
